var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-badge',{attrs:{"offset-x":"0","offset-y":"5","color":_vm.options.color}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }